import React, { Component } from 'react';
import $j from 'jquery';
import { DarkButton } from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';
import Icon from '../../../../helper/Icon';

export default class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: this.props.defaultOpen
    };
  }

  state = {
    showContent: false
  };

  toggleSectionOpen = open => () => {
    if (open) {
      this.setState({
        showContent: open
      });
      $j(this.wrapperRef)
        .find('.sectionContentDark')
        .stop(true, true)
        .slideDown();
    } else {
      this.setState({
        showContent: open
      });
      $j(this.wrapperRef)
        .find('.sectionContentDark')
        .stop(true, true)
        .slideUp();
    }
  };

  render() {
    return (
      <div className="" ref={ref => (this.wrapperRef = ref)}>
        <div
          role="presentation"
          className={'sectionInfoContainer' + (this.state.showContent ? ' active' : '')}
          onClick={this.toggleSectionOpen(!this.state.showContent)}
        >
          <div className="sectionIconContainer">
            <DarkButton.IconButton>
              <Icon
                icon={this.state.showContent ? 'remove' : 'add'}
                size="24px"
                fill={themeConfig.color.dark.silver}
              />
            </DarkButton.IconButton>
          </div>
          <div className="sectionLabel">{this.props.title}</div>
        </div>
        <div className="sectionContentDark">{this.props.children}</div>
      </div>
    );
  }
}

Section.defaultProps = {
  defaultOpen: true
};
